/* Elasticity listicle — one-tap add-to-cart for the sticky buy bar and the
 * inline quick-add cards. One predictable, in-app-browser-safe behavior:
 * POST /cart/add.js, fire the existing GA4 + Meta Pixel events, then a
 * full-page redirect to /cart (nicest confirmation inside IG/FB WebViews,
 * where the header cart icon is hidden on this lander).
 *
 * Reuses the EXISTING Meta Pixel and GA4 — never instantiates either. Every
 * call is guarded; if fbq/gtag are absent the calls no-op cleanly. Does NOT
 * touch Purchase / checkout wiring. All listeners fail closed.
 *
 * A button opts in with [data-elx-quickadd] and carries:
 *   data-variant-id (required), data-qty, data-plan (blank = one-time),
 *   data-gift-variant (added alongside 3-bag adds; blank = no gift),
 *   data-value, data-currency, data-content-id, data-placement, data-redirect.
 */
(function () {
  'use strict';

  function ga(name, params) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', name, Object.assign({ event_category: 'listicle_lp' }, params || {}));
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: name, event_category: 'listicle_lp' }, params || {}));
      }
    } catch (e) { /* swallow */ }
  }
  function fb(event, params) {
    try {
      if (typeof window.fbq === 'function') { window.fbq('track', event, params || {}); }
    } catch (e) { /* swallow */ }
  }
  function slug(s) { return String(s || 'unknown').replace(/[^a-z0-9]+/gi, '_').toLowerCase(); }

  function wire(btn) {
    var busy = false;
    var labelEl = btn.querySelector('[data-elx-quickadd-label]') || btn;
    var defaultLabel = labelEl.textContent;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (busy || btn.disabled) return;

      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
      var plan = parseInt(btn.getAttribute('data-plan'), 10) || 0;
      var value = Number(btn.getAttribute('data-value')) || 0;
      var currency = btn.getAttribute('data-currency') || 'USD';
      var contentId = btn.getAttribute('data-content-id') || '';
      var placement = btn.getAttribute('data-placement') || 'quickadd';
      var redirect = btn.getAttribute('data-redirect') || '/cart';

      var item = { id: variantId, quantity: qty };
      if (plan) { item.selling_plan = plan; }
      var items = [item];
      var giftVariantId = parseInt(btn.getAttribute('data-gift-variant'), 10) || 0;
      if (qty === 3 && giftVariantId) { items.push({ id: giftVariantId, quantity: 1 }); }

      busy = true;
      btn.disabled = true;
      labelEl.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          fb('AddToCart', { content_ids: [contentId], content_type: 'product', value: value, currency: currency, num_items: qty });
          ga('add_to_cart', {
            event_label: placement,
            cta_position: placement,
            purchase_type: plan ? 'subscribe' : 'onetime',
            quantity: qty,
            selling_plan: plan || '',
            currency: currency,
            value: value
          });
          ga('cta_click_' + slug(placement), { event_label: placement, cta_position: placement });
          labelEl.textContent = 'Added ✓';
          btn.classList.add('is-added');
          window.setTimeout(function () { window.location.href = redirect; }, 400);
        })
        .catch(function () {
          labelEl.textContent = 'Try again';
          btn.disabled = false;
          busy = false;
          window.setTimeout(function () { labelEl.textContent = defaultLabel; }, 2000);
        });
    });
  }

  function init() {
    var btns = document.querySelectorAll('[data-elx-quickadd]');
    for (var i = 0; i < btns.length; i++) { wire(btns[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
